module.exports = __webpack_public_path__ + "img/x11.98b63717.jpg";